import React from 'react'
// import { usePopperTooltip } from 'react-popper-tooltip'
import 'react-popper-tooltip/dist/styles.css'

const FileInput = ({
  id,
  title,
  name,
  b64,
  value,
  onChange,
}) => {
  
  return (
    <div className="mb-1">
      <label htmlFor={id} className="form-label">{title}</label>
      {/* <i className="fas fa-info-circle ms-2"
      ref={setTriggerRef}></i> */}
      
      <input 
        type="file"
        id={id}
        name={name}
        // value={value}
        className="form-control"
        accept="image/png, image/jpeg, image/jpg"
        onChange={(e) => {
          onChange(e)
        }}
      />
      
    </div>
  )
}

export default FileInput
